import SortableTable from './SortableTable';

export type { SortableTableRef } from './SortableTable';

export default SortableTable;
